// import MUIDataTable from "mui-datatables";
// import useFetch from "../services/employeeService";

// const columns = [
//   "name",
//   "email",
//   "phone",
//   {
//     name: "Actions",
//     options: {
//       filter: false,
//       sort: false,
//       empty: true,
//       customBodyRenderLite: (dataIndex) => {
//         return (
//           <button
//             onClick={() => {
//               const { data } = this.state;
//               data.shift();
//               this.setState({ data });
//             }}
//           >
//             Delete
//           </button>
//         );
//       },
//     },
//   },
// ];
// // const data = [
// //   ["Joe James", "Test Corp", "Yonkers", "NY"],
// //   ["John Walsh", "Test Corp", "Hartford", "CT"],
// //   ["Bob Herm", "Test Corp", "Tampa", "FL"],
// //   ["James Houston", "Test Corp", "Dallas", "TX"],
// // ];
// const options = {
//   filterType: "checkbox",
// };

// export default function EmployeeList() {
//   const { error, isPending, data } = useFetch(
//     "https://jsonplaceholder.typicode.com/users"
//   );

//   return (
//     <div>
//       {data && (
//         <MUIDataTable
//           title={"Employee List"}
//           data={data}
//           columns={columns}
//           options={options}
//         />
//       )}
//     </div>
//   );
// }

// import React from "react";
// import { CircularProgress, Typography } from "@material-ui/core";
// import MUIDataTable from "mui-datatables";

// class Example extends React.Component {
//   state = {
//     page: 0,
//     count: 1,
//     rowsPerPage: 5,
//     sortOrder: {},
//     data: [["Loading Data..."]],
//     columns: [
//       {
//         name: "fullName",
//         label: "Full Name",
//         options: {
//           customBodyRender: (value, tableMeta, updateValue) => {
//             // Here you can render a more complex display.
//             // You're given access to tableMeta, which has
//             // the rowData (as well as the original object data).
//             // See the console for a detailed look at this object.

//             // console.log("customBodyRender");
//             console.dir(tableMeta);
//             return value;
//           },
//         },
//       },
//       {
//         name: "title",
//         label: "Title",
//         options: {},
//       },
//       {
//         name: "location",
//         label: "Location",
//         options: {},
//       },
//     ],
//     isLoading: false,
//   };

//   componentDidMount() {
//     this.getData("", 0);
//   }

//   // get data
//   getData = async (url, page) => {
//     this.setState({ isLoading: true });
//     const res = await this.xhrRequest(url, page);
//     this.setState({ data: res.data, isLoading: false, count: res.total });
//   };

//   getSrcData = () => {
//     return [
//       {
//         fullName: "Gabby George",
//         title: "Business Analyst",
//         location: "Minneapolis",
//       },
//       {
//         fullName: "Aiden Lloyd",
//         title: "Business Consultant",
//         location: "Dallas",
//       },
//       { fullName: "Jaden Collins", title: "Attorney", location: "Santa Ana" },
//       {
//         fullName: "Franky Rees",
//         title: "Business Analyst",
//         location: "St. Petersburg",
//       },
//       { fullName: "Aaren Rose", title: "Business Analyst", location: "Toledo" },

//       {
//         fullName: "John George",
//         title: "Business Analyst",
//         location: "Washington DC",
//       },
//       {
//         fullName: "Pat Lloyd",
//         title: "Computer Programmer",
//         location: "Baltimore",
//       },
//       {
//         fullName: "Joe Joe Collins",
//         title: "Attorney",
//         location: "Las Cruces",
//       },
//       { fullName: "Franky Hershy", title: "Paper Boy", location: "El Paso" },
//       {
//         fullName: "Aaren Smalls",
//         title: "Business Analyst",
//         location: "Tokyo",
//       },

//       { fullName: "Boogie G", title: "Police Officer", location: "Unknown" },
//       {
//         fullName: "James Roulf",
//         title: "Business Consultant",
//         location: "Video Game Land",
//       },
//       {
//         fullName: "Mike Moocow",
//         title: "Burger King Employee",
//         location: "New York",
//       },
//       {
//         fullName: "Mimi Gerock",
//         title: "Business Analyst",
//         location: "McCloud",
//       },
//       {
//         fullName: "Jason Evans",
//         title: "Business Analyst",
//         location: "Mt Shasta",
//       },

//       {
//         fullName: "Simple Sam",
//         title: "Business Analyst",
//         location: "Mt Shasta",
//       },
//       {
//         fullName: "Marky Mark",
//         title: "Business Consultant",
//         location: "Las Cruces",
//       },
//       { fullName: "Jaden Jam", title: "Attorney", location: "El Paso" },
//       {
//         fullName: "Holly Jo",
//         title: "Business Analyst",
//         location: "St. Petersburg",
//       },
//       { fullName: "Suzie Q", title: "Business Analyst", location: "New York" },
//     ];
//   };

//   sort = (page, sortOrder) => {
//     this.setState({ isLoading: true });
//     this.xhrRequest("", page, sortOrder).then((res) => {
//       this.setState({
//         data: res.data,
//         page: res.page,
//         sortOrder,
//         isLoading: false,
//         count: res.total,
//       });
//     });
//   };

//   // mock async function
//   xhrRequest = (url, page, sortOrder = {}) => {
//     return new Promise((resolve, reject) => {
//       // mock page data
//       let fullData = this.getSrcData();
//       const total = fullData.length; // mock record count from server - normally this would be a number attached to the return data

//       let sortField = sortOrder.name;
//       let sortDir = sortOrder.direction;

//       if (sortField) {
//         fullData = fullData.sort((a, b) => {
//           if (a[sortField] < b[sortField]) {
//             return 1 * (sortDir === "asc" ? -1 : 1);
//           } else if (a[sortField] > b[sortField]) {
//             return -1 * (sortDir === "asc" ? -1 : 1);
//           } else {
//             return 0;
//           }
//         });
//       }

//       const srcData = fullData.slice(
//         page * this.state.rowsPerPage,
//         (page + 1) * this.state.rowsPerPage
//       );
//       let data = srcData;

//       setTimeout(() => {
//         resolve({
//           data,
//           total,
//           page,
//         });
//       }, 1000);
//     });
//   };

//   changePage = (page, sortOrder) => {
//     this.setState({
//       isLoading: true,
//     });
//     this.xhrRequest(`/myApiServer?page=${page}`, page, sortOrder).then(
//       (res) => {
//         this.setState({
//           isLoading: false,
//           page: res.page,
//           sortOrder,
//           data: res.data,
//           count: res.total,
//         });
//       }
//     );
//   };

//   render() {
//     const { data, page, count, isLoading, rowsPerPage, sortOrder } = this.state;

//     const options = {
//       filter: true,
//       filterType: "dropdown",
//       responsive: "vertical",
//       serverSide: true,
//       count: count,
//       rowsPerPage: rowsPerPage,
//       rowsPerPageOptions: [],
//       sortOrder: sortOrder,
//       onTableChange: (action, tableState) => {
//         // console.log(action, tableState);

//         // a developer could react to change on an action basis or
//         // examine the state as a whole and do whatever they want

//         switch (action) {
//           case "changePage":
//             this.changePage(tableState.page, tableState.sortOrder);
//             break;
//           case "sort":
//             this.sort(tableState.page, tableState.sortOrder);
//             break;
//           default:
//             // console.log("action not handled.");
//         }
//       },
//     };

//     // console.log("COLUMNS");
//     console.dir(JSON.parse(JSON.stringify(this.state.columns)));

//     return (
//       <div>
//         <MUIDataTable
//           title={
//             <Typography variant="h6">
//               ACME Employee list
//               {isLoading && (
//                 <CircularProgress
//                   size={24}
//                   style={{ marginLeft: 15, position: "relative", top: 4 }}
//                 />
//               )}
//             </Typography>
//           }
//           data={data}
//           columns={this.state.columns}
//           options={options}
//         />
//       </div>
//     );
//   }
// }

// export default Example;

import React from "react";
import ReactDOM from "react-dom";
import MUIDataTable from "mui-datatables";
import { TableFooter, TableCell, TableRow } from "@material-ui/core";

class Example extends React.Component {
  render() {
    const columns = ["Name", "Title", "Location", "Age", "Salary"];

    let data = [
      ["Gabby George", "Business Analyst", "Minneapolis", 30, 100000],
      ["Aiden Lloyd", "Business Consultant", "Dallas", 55, 200000],
      ["Jaden Collins", "Attorney", "Santa Ana", 27, 500000],
      ["Franky Rees", "Business Analyst", "St. Petersburg", 22, 50000],
      ["Aaren Rose", "Business Consultant", "Toledo", 28, 75000],
      ["Blake Duncan", "Business Management Analyst", "San Diego", 65, 94000],
      ["Frankie Parry", "Agency Legal Counsel", "Jacksonville", 71, 210000],
      ["Lane Wilson", "Commercial Specialist", "Omaha", 19, 65000],
      ["Robin Duncan", "Business Analyst", "Los Angeles", 20, 77000],
      ["Mel Brooks", "Business Consultant", "Oklahoma City", 37, 135000],
      ["Harper White", "Attorney", "Pittsburgh", 52, 420000],
      ["Kris Humphrey", "Agency Legal Counsel", "Laredo", 30, 150000],
      ["Frankie Long", "Industrial Analyst", "Austin", 31, 170000],
      ["Brynn Robbins", "Business Analyst", "Norfolk", 22, 90000],
      ["Justice Mann", "Business Consultant", "Chicago", 24, 133000],
      [
        "Addison Navarro",
        "Business Management Analyst",
        "New York",
        50,
        295000,
      ],
      ["Jesse Welch", "Agency Legal Counsel", "Seattle", 28, 200000],
      ["Eli Mejia", "Commercial Specialist", "Long Beach", 65, 400000],
      ["Gene Leblanc", "Industrial Analyst", "Hartford", 34, 110000],
      ["Danny Leon", "Computer Scientist", "Newark", 60, 220000],
      ["Lane Lee", "Corporate Counselor", "Cincinnati", 52, 180000],
      ["Jesse Hall", "Business Analyst", "Baltimore", 44, 99000],
      ["Danni Hudson", "Agency Legal Counsel", "Tampa", 37, 90000],
      ["Terry Macdonald", "Commercial Specialist", "Miami", 39, 140000],
      ["Justice Mccarthy", "Attorney", "Tucson", 26, 330000],
      ["Silver Carey", "Computer Scientist", "Memphis", 47, 250000],
      ["Franky Miles", "Industrial Analyst", "Buffalo", 49, 190000],
      ["Glen Nixon", "Corporate Counselor", "Arlington", 44, 80000],
      [
        "Gabby Strickland",
        "Business Process Consultant",
        "Scottsdale",
        26,
        45000,
      ],
      ["Mason Ray", "Computer Scientist", "San Francisco", 39, 142000],
    ];

    const options = {
      filter: true,
      selectableRows: true,
      filterType: "dropdown",
      rowsPerPage: 3,
      customFooter: (
        count,
        page,
        rowsPerPage,
        changeRowsPerPage,
        changePage
      ) => {
        const startIndex = page * rowsPerPage;
        const endIndex = (page + 1) * rowsPerPage;
        return (
          <TableFooter>
            <TableRow>
              <TableCell colSpan={6}>
                Total Salery for current page: {sumSalery(startIndex, endIndex)}
              </TableCell>
            </TableRow>
          </TableFooter>
        );
      },
    };

    const sumSalery = (startIndex, endIndex) => {
      return data
        .slice(startIndex, endIndex)
        .map((a) => a[4])
        .reduce((total, salery) => (total += salery), 0);
    };

    return (
      <div>
        <MUIDataTable
          title={"ACME Employee list"}
          data={data}
          columns={columns}
          options={options}
        />
        <TableFooter>
          <TableRow>
            <h3>some content</h3>
          </TableRow>
        </TableFooter>
      </div>
    );
  }
}

export default Example;
